var chunkMapping = {
	"141": [
		6141
	],
	"200": [
		5437
	],
	"509": [
		509
	],
	"529": [
		9059
	],
	"603": [
		603
	],
	"632": [
		3632
	],
	"735": [
		7735
	],
	"849": [
		5849
	],
	"851": [
		6851
	]
};
var idToExternalAndNameMapping = {
	"509": [
		"default",
		"./mutation-grid-header",
		1688
	],
	"603": [
		"default",
		"./filter-select",
		19
	],
	"3632": [
		"default",
		"./document-list",
		19
	],
	"5437": [
		"default",
		"./atoms",
		1688
	],
	"5849": [
		"default",
		"./revert-mutation-modal",
		1688
	],
	"6141": [
		"default",
		"./mutation-grid-content",
		1688
	],
	"6851": [
		"default",
		"./contribution-table",
		2856
	],
	"7735": [
		"default",
		"./mutation-grid-item",
		1688
	],
	"9059": [
		"default",
		"./handlers",
		19
	]
};
var idToRemoteMap = {
	"509": [
		{
			"externalType": "script",
			"name": "mutationsApp"
		}
	],
	"603": [
		{
			"externalType": "script",
			"name": "documentApp"
		}
	],
	"3632": [
		{
			"externalType": "script",
			"name": "documentApp"
		}
	],
	"5437": [
		{
			"externalType": "script",
			"name": "mutationsApp"
		}
	],
	"5849": [
		{
			"externalType": "script",
			"name": "mutationsApp"
		}
	],
	"6141": [
		{
			"externalType": "script",
			"name": "mutationsApp"
		}
	],
	"6851": [
		{
			"externalType": "script",
			"name": "contribuitionApp"
		}
	],
	"7735": [
		{
			"externalType": "script",
			"name": "mutationsApp"
		}
	],
	"9059": [
		{
			"externalType": "script",
			"name": "documentApp"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"509": {
		"shareScope": "default",
		"name": "./mutation-grid-header",
		"externalModuleId": 1688,
		"remoteName": "mutationsApp"
	},
	"603": {
		"shareScope": "default",
		"name": "./filter-select",
		"externalModuleId": 19,
		"remoteName": "documentApp"
	},
	"3632": {
		"shareScope": "default",
		"name": "./document-list",
		"externalModuleId": 19,
		"remoteName": "documentApp"
	},
	"5437": {
		"shareScope": "default",
		"name": "./atoms",
		"externalModuleId": 1688,
		"remoteName": "mutationsApp"
	},
	"5849": {
		"shareScope": "default",
		"name": "./revert-mutation-modal",
		"externalModuleId": 1688,
		"remoteName": "mutationsApp"
	},
	"6141": {
		"shareScope": "default",
		"name": "./mutation-grid-content",
		"externalModuleId": 1688,
		"remoteName": "mutationsApp"
	},
	"6851": {
		"shareScope": "default",
		"name": "./contribution-table",
		"externalModuleId": 2856,
		"remoteName": "contribuitionApp"
	},
	"7735": {
		"shareScope": "default",
		"name": "./mutation-grid-item",
		"externalModuleId": 1688,
		"remoteName": "mutationsApp"
	},
	"9059": {
		"shareScope": "default",
		"name": "./handlers",
		"externalModuleId": 19,
		"remoteName": "documentApp"
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}